import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPublicIp = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-public-ip';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.378 2.282c-2.67.2-5.137 1.894-6.319 4.338-1.104 2.282-1.07 4.945.092 7.16l.189.36 2.44 2.147 2.44 2.147.011.423.012.423H4v1.48h6.24v1h3.52v-1H20v-1.48h-6.243l.012-.423.011-.423 2.44-2.147 2.44-2.147.189-.36c1.603-3.056 1.023-6.826-1.429-9.28-1.58-1.582-3.775-2.387-6.042-2.218m1.402 1.522c2.492.304 4.619 2.197 5.255 4.678.38 1.481.203 3.236-.448 4.449l-.167.312-2.71 2.379-2.71 2.38-2.736-2.406-2.735-2.406-.164-.345c-.637-1.343-.777-2.972-.384-4.443.337-1.257 1.139-2.476 2.168-3.299.832-.664 2.009-1.169 3.019-1.296a8.4 8.4 0 0 1 1.612-.003M9.7 6.817a.76.76 0 0 0-.384.399c-.07.156-.074.325-.074 3.284 0 2.953.004 3.129.074 3.28.286.619 1.082.619 1.368 0 .07-.151.074-.327.074-3.28s-.004-3.129-.074-3.28c-.086-.186-.257-.357-.417-.417a.9.9 0 0 0-.567.014m2.501.006a.65.65 0 0 0-.365.345c-.073.142-.076.287-.076 3.332s.003 3.19.076 3.332a.64.64 0 0 0 .374.346.74.74 0 0 0 .58 0 .61.61 0 0 0 .375-.358c.064-.14.073-.273.074-1.07l.001-.91h.552c.633 0 .882-.05 1.322-.265a2 2 0 0 0 1.061-1.338c.088-.354.089-1.508.003-1.873-.192-.818-.754-1.374-1.558-1.544-.404-.085-2.221-.083-2.419.003m2.272 1.513c.221.115.265.274.266.964.001.696-.034.803-.31.948-.143.076-.248.092-.679.105l-.51.015V8.23l.55.018c.418.014.582.035.683.088"
    })
  }));
});
export default SvgPublicIp;